import SearchIcon from "@/User/Assets/Svgs/SearchPrimaryIcon.svg";
import SearchWhiteIcon from "@/User/Assets/Svgs/SearchWhiteIcon.svg";
import SecondaryButton from '@/User/Components//Buttons/SecondaryButton';
import EntryButton from "@/User/Components/Buttons/EntryButton";
import AreaSelect from "@/User/Pages/Top/Components/ConditionSearch/AreaSelect";
import BudgetSelect from "@/User/Pages/Top/Components/ConditionSearch/BudgetSelect";
import BusinessSelect from "@/User/Pages/Top/Components/ConditionSearch/BusinessSelect";
import ThemeSelect from "@/User/Pages/Top/Components/ConditionSearch/ThemeSelect";
import { router, usePage } from "@inertiajs/react";
import { map } from "lodash";
import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import route from 'ziggy-js';

const ConditionSearch = ({
    showEntryButton = true,
}) => {
    const { auth: { user } } = usePage().props;
    const [searchData, setSearchData] = useState({
        industries: [],
        budgets: [],
        themes: [],
        prefs: [],
    });

    const handleSelectChangeValue = (key, newValues) => setSearchData({
        ...searchData,
        [key]: [...map(newValues, (item) => item.value)],
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        let query = {};

        if (searchData.industries.length) {
            query = { ...query, business: searchData.industries };
        }
        if (searchData.budgets.length) {
            query = { ...query, budget: searchData.budgets };
        }
        if (searchData.themes.length) {
            query = { ...query, theme: searchData.themes };
        }
        if (searchData.prefs.length) {
            query = { ...query, pref: searchData.prefs };
        }

        if (Object.keys(query).length === 0 || Object.keys(query).length > 1) {
            router.visit(route('search_page', query));
            return;
        }

        if (query?.business) {
            router.visit(route('business_page', query?.business.length === 1
                ? { id: query.business[0] }
                : { business: query.business }
            ));
            return;
        }

        if (query?.budget) {
            router.visit(route('budget_page', query?.budget.length === 1
                ? { id: query.budget[0] }
                : { budget: query.budget }
            ));
            return;
        }

        if (query?.theme) {
            router.visit(route('theme_page', query?.theme.length === 1
                ? { id: query.theme[0] }
                : { theme: query.theme }
            ));
            return;
        }

        if (query?.pref) {
            router.visit(route('area_page', query?.pref.length === 1
                ? { id: query.pref[0] }
                : { pref: query.pref }
            ));
        }
    };

    return (
        <section id="condition-search"
            className="bg-zircon border-y border-pattens-blue">
            <div className="container py-6 lg:py-10 flex justify-center items-center flex-col gap-2">
                <div className="text-center text-primary mb-2">
                    <div className="flex justify-center items-center mb-2.5">
                        <LazyLoadImage src={SearchIcon} alt="新着案件から探す" className="size-6" />
                    </div>
                    <h2 className="leading-tight">条件を指定して探す</h2>
                </div>

                <div className="w-full md:w-85.5 max-w-full flex flex-col gap-4">
                    <BusinessSelect
                        id='business'
                        handleChange={(newOptions) => handleSelectChangeValue('industries', newOptions)}
                        values={searchData.industries}
                    />
                    <BudgetSelect
                        id='budget'
                        handleChange={(newOptions) => handleSelectChangeValue('budgets', newOptions)}
                        values={searchData.budgets}
                    />
                    <AreaSelect
                        id='area'
                        handleChange={(newOptions) => handleSelectChangeValue('prefs', newOptions)}
                        values={searchData.prefs}
                    />
                    <ThemeSelect
                        id='theme'
                        handleChange={(newOptions) => handleSelectChangeValue('themes', newOptions)}
                        values={searchData.themes}
                    />

                    {!user && (
                        <p className="text-midnight pt-5.5px">※会員未登録の場合、案件の一部のみの閲覧となります。</p>
                    )}
                </div>

                <div className="w-full mt-5.5px md:w-85.5 max-w-full flex flex-col gap-3">
                    <SecondaryButton textClass="text-base text-white"
                        isRounded={true} roundedClass="rounded-lg"
                        isShadow={true} shadowClass="shadow-base"
                        className="px-10 py-4"
                        onClick={(e) => handleSubmit(e)}
                    >
                        募集案件を探す
                        <LazyLoadImage src={SearchWhiteIcon} alt="求人を探す" className="inline-block ml-2 size-6" />
                    </SecondaryButton>

                    {showEntryButton && <EntryButton classIconName='size-6' />}
                </div>
            </div>
        </section>
    );
};

export default ConditionSearch;
